import React from 'react';
import { useParams } from 'react-router-dom';
import LibraryPage from '../domains/library/LibraryPage';
import UniverseExplorer from '../domains/library/UniverseExplorer';

export default function Library() {
  const wildcard = useParams()['*'] || '';
  return wildcard === 'cards' ? <LibraryPage /> : <UniverseExplorer />;
}
